import React from 'react';

function withdrawal() {
    return (
        <div className="container">
            <div className="row mb-4">
                <div className="col-md-3">
                    <div
                        className="p-3 text-center border"
                        style={{
                            borderRadius: '10px',
                            backgroundColor: '#f8f9fa',
                        }}
                    >
                        <div>
                            <img
                                src="https://uxwing.com/wp-content/themes/uxwing/download/banking-finance/money-bag-dollar-color-icon.svg"
                                alt="Total Amount"
                                width="50"
                                className="mb-2"
                            />
                        </div>
                        <h6 className="text-primary">Tổng số tiền đã rút                        </h6>
                        <h5>0 ₫</h5>
                    </div>
                </div>
                <div className="col-md-3">
                    <div
                        className="p-3 text-center border"
                        style={{
                            borderRadius: '10px',
                            backgroundColor: '#f8f9fa',
                        }}
                    >
                        <div>
                            <img
                                src="https://png.pngtree.com/png-vector/20220209/ourmid/pngtree-dollar-wallet-coin-vector-icon-png-image_4379737.png"
                                alt="Total Benefits"
                                width="70"
                                className="mb-2"
                            />
                        </div>
                        <h6 className="text-warning">Tổng tiền đang yêu cầu rút
                        </h6>
                        <h5>0 ₫</h5>
                    </div>
                </div>
                <div className="col-md-3">
                    <div
                        className="p-3 text-center border"
                        style={{
                            borderRadius: '10px',
                            backgroundColor: '#f8f9fa',
                        }}
                    >
                        <div>
                            <img
                                src="https://img.pikbest.com/origin/09/25/00/15XpIkbEsTbJq.png!sw800"
                                alt="First-Time Benefit"
                                width="70"
                                className="mb-2"
                            />
                        </div>
                        <h6 className="text-danger">Tổng yêu cầu được duyệt                        </h6>
                        <h5>20%</h5>
                    </div>
                </div>
                <div className="col-md-3">
                    <div
                        className="p-3 text-center border"
                        style={{
                            borderRadius: '10px',
                            backgroundColor: '#f8f9fa',
                        }}
                    >
                        <div>
                            <img
                                src="https://png.pngtree.com/element_our/20190531/ourmid/pngtree-financial-identity-stickman-illustration-image_1293714.jpg"
                                alt="Next-Time Benefit"
                                width="70"
                                className="mb-2"
                            />
                        </div>
                        <h6 className="text-danger">Tổng tiền đang có                        </h6>
                        <h5>10%</h5>
                    </div>
                </div>
            </div>

            {/* Filters */}
            <div className="row mb-4">
                <div className="col-md-4">
                    <label htmlFor="startDate" className="form-label">
                        Từ ngày
                    </label>
                    <input
                        type="date"
                        id="startDate"
                        className="form-control"
                    />
                </div>
                <div className="col-md-4">
                    <label htmlFor="endDate" className="form-label">
                        Đến ngày
                    </label>
                    <input
                        type="date"
                        id="endDate"
                        className="form-control"
                    />
                </div>
                <div className="col-md-4 d-flex align-items-end">
                    <button className="btn btn">Search</button>
                </div>
            </div>

            {/* Table */}
            <div className="row">
                <div className="col-md-12">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Số tiền rút	</th>
                                <th>Trạng thái	</th>
                                <th>Ngày tạo</th>
                                <th>Ngày cập nhật	</th>
                                <th>Ghi Chú </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan="5" className="text-center">
                                    Không có dữ liệu
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default withdrawal;
